import { render, staticRenderFns } from "./MP100vsMB100.vue?vue&type=template&id=08684208&"
import script from "./MP100vsMB100.vue?vue&type=script&lang=js&"
export * from "./MP100vsMB100.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports